import Head from 'next/head'
import { CircuitAuditScheduler } from '../components/ui/circuit-audit-scheduler'
import { SiteFooter, SiteHeader } from '../components/ui/site-chrome'

export default function Book() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <Head>
        <title>Book a Zadro Diagnostic | Fractional CTO & AI Strategy</title>
        <meta
          name="description"
          content="Start a conversation with Juan Cubeddu about fractional CTO support, AI workshops, technical audits, and complex systems problem solving."
        />
      </Head>
      <SiteHeader current="/book" />
      <main className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <a href="/" className="mb-10 font-mono text-sm font-semibold uppercase tracking-[0.24em] text-sky-300">
          Zadro
        </a>
        <div className="my-10 grid gap-8 lg:grid-cols-[1fr_0.72fr] lg:items-center">
          <div className="max-w-4xl">
            <p className="section-kicker">Book a diagnostic</p>
            <h1 className="mt-4 text-5xl font-black leading-[0.96] tracking-tight text-white sm:text-6xl">
              Bring the messy technical problem. We will map the next move.
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-300">
              Use this first conversation for fractional CTO fit, AI strategy, workshop planning, or a
              platform bottleneck that needs senior technical eyes. The best calls start with a specific
              business outcome and the system that is blocking it.
            </p>
          </div>
          <div className="overflow-hidden rounded-[1.5rem] border border-slate-800 bg-slate-950 shadow-[0_24px_80px_rgba(2,6,23,0.42)]">
            <img
              src="/header-images/compute-diagnostic.svg"
              alt="Diagnostic call system map visualization"
              className="h-72 w-full object-cover"
            />
          </div>
        </div>
        <CircuitAuditScheduler />
      </main>
      <SiteFooter />
    </div>
  )
}
